import { OperatorFunction } from "rxjs";
import { filter, map, distinctUntilChanged } from "rxjs/operators";

import { ApiStateStoreState } from "../api-state-store.service";
import { ApiSessionState } from "../api-session.service";

export function userId(): OperatorFunction<ApiStateStoreState, string> {
  return storeState =>
    storeState.pipe(
      map(store => (store.Session?.state as ApiSessionState).userId),
      filter(<T>(val: T): val is NonNullable<T> => !!val),
      distinctUntilChanged()
    );
}
